"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Caption1Strong: function() {
        return _index.Caption1Strong;
    },
    caption1StrongClassNames: function() {
        return _index.caption1StrongClassNames;
    }
});
const _index = require("./components/presets/Caption1Strong/index");
